import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { arrowChevronRight } from '@ibk/shared-assets';
import styles from './EstablishmentCard.module.css';
const getInitials = (name) => {
    if (!name)
        return '';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 1)
        return parts[0].slice(0, 2).toUpperCase();
    return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
};
export const EstablishmentCard = ({ establishment, onClick, className = '' }) => {
    const fullAddress = `${establishment.streetName}, ${establishment.number} - ${establishment.neighborhood}, ${establishment.city} - ${establishment.state}, ${establishment.postalCode}`;
    const formattedDistance = useMemo(() => {
        const formatter = new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
        });
        return `${formatter.format(establishment.location.distance)}km`;
    }, [establishment.location.distance]);
    const initials = useMemo(() => getInitials(establishment.companyName), [establishment.companyName]);
    const ariaLabel = `${establishment.companyName} - ${formattedDistance}`;
    return (_jsxs("button", { type: 'button', onClick: () => onClick?.(establishment), className: `${styles.cards} ${className}`, role: 'listitem', "aria-label": ariaLabel, "data-testid": 'establishment-card', children: [_jsx("div", { className: styles.avatar, "aria-hidden": 'true', children: _jsx("span", { className: styles.avatarInitials, children: initials }) }), _jsxs("div", { className: styles.mainContent, children: [_jsxs("div", { className: styles.headerRow, children: [_jsx("h3", { className: styles.companyName, children: establishment.companyName }), _jsx("img", { src: arrowChevronRight, alt: '', "aria-hidden": 'true', className: styles.chevron })] }), _jsx("p", { className: styles.distance, "data-testid": 'establishment-distance', children: formattedDistance }), _jsx("p", { className: styles.address, children: fullAddress })] })] }));
};
